import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "menu"];
  static values = { open: Boolean };

  connect() {
    if (this.openValue) this.menuTarget.classList.remove("hidden");
  }

  toggle(e) {
    e.preventDefault();
    e.stopPropagation();

    this.menuTarget.classList.toggle("hidden");
  }
}
